module.exports = __webpack_public_path__ + "img/special2-3.b9ebe0f8.png";